
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: "user",
    initialState: {
        authUser: null,
        otherUsers: [],
        allUsers: [],
        selectedUser: null,
        onlineUsers: null,
        unreadMessages: {},
        lastMessageTimestamps: {},
        lastUnreadMessageId: {},
        lastMessages: {},
        pagination: {
            page: 1,
            hasMore: true,
            loadingMore: false
        },
        searchResults: null,
    },
    reducers: {
        setAuthUser: (state, action) => {
            state.authUser = action.payload;
        },

        // setOtherUsers: (state, action) => {
        //     const incomingUsers = Array.isArray(action.payload) ? action.payload : [];

        //     // Strict validation of user objects
        //     const validUsers = incomingUsers.filter(user =>
        //         user?._id &&
        //         typeof user.username === 'string'
        //     );

        //     state.otherUsers = validUsers;

        //     // Update last messages and timestamps
        //     validUsers.forEach(user => {
        //         if (user.lastMessageTime) {
        //             state.lastMessageTimestamps[user._id] = new Date(user.lastMessageTime).getTime();
        //         }
        //         if (user.lastMessageContent) {
        //             state.lastMessages[user._id] = user.lastMessageContent;
        //         }
        //     });

        //     // Stable sorting
        //     state.otherUsers = [...validUsers].sort((a, b) => {
        //         const timeA = state.lastMessageTimestamps[a._id] || 0;
        //         const timeB = state.lastMessageTimestamps[b._id] || 0;
        //         return timeB - timeA;
              
        //     });
        // },

//         setOtherUsers: (state, action) => {
//     const incomingUsers = Array.isArray(action.payload) ? action.payload : [];

//     const validUsers = incomingUsers.filter(user =>
//         user?._id && typeof user.username === 'string'
//     );

//     // Create a map of existing users
//     const existingUsersMap = new Map(state.otherUsers.map(user => [user._id, user]));

//     // Update existing or insert new
//     validUsers.forEach(user => {
//         const existing = existingUsersMap.get(user._id);
//         if (existing) {
//             // Merge updated fields
//             existingUsersMap.set(user._id, {
//                 ...existing,
//                 ...user,
//                 lastMessageTime: user.lastMessageTime || existing.lastMessageTime,
//                 lastMessageContent: user.lastMessageContent || existing.lastMessageContent
//             });
//         } else {
//             existingUsersMap.set(user._id, {
//                 ...user,
//                 lastMessageTime: user.lastMessageTime || new Date(0).toISOString(),
//                 lastMessageContent: user.lastMessageContent || ''
//             });
//         }

//         if (user.lastMessageTime) {
//             state.lastMessageTimestamps[user._id] = new Date(user.lastMessageTime).getTime();
//         }
//         if (user.lastMessageContent) {
//             state.lastMessages[user._id] = user.lastMessageContent;
//         }
//     });

//     // Rebuild the otherUsers array and sort
//     state.otherUsers = Array.from(existingUsersMap.values()).sort((a, b) => {
//         const timeA = state.lastMessageTimestamps[a._id] || 0;
//         const timeB = state.lastMessageTimestamps[b._id] || 0;
//         return timeB - timeA;
//     });
// }
// ,

setOtherUsers: (state, action) => {
    const incomingUsers = Array.isArray(action.payload) ? action.payload : [];

    const validUsers = incomingUsers.filter(user =>
        user?._id && typeof user.username === 'string'
    );

    // Merge users: update existing, add new
    const updatedUsersMap = new Map();
    [...state.otherUsers, ...validUsers].forEach(user => {
        updatedUsersMap.set(user._id, {
            ...updatedUsersMap.get(user._id), // existing if present
            ...user // override with latest data
        });
    });

    const mergedUsers = Array.from(updatedUsersMap.values());

    // Update last messages and timestamps
    mergedUsers.forEach(user => {
        if (user.lastMessageTime) {
            state.lastMessageTimestamps[user._id] = new Date(user.lastMessageTime).getTime();
        }
        if (user.lastMessageContent) {
            state.lastMessages[user._id] = user.lastMessageContent;
        }
    });

    // Sort users
    state.otherUsers = mergedUsers.sort((a, b) => {
        const timeA = state.lastMessageTimestamps[a._id] || 0;
        const timeB = state.lastMessageTimestamps[b._id] || 0;
        return timeB - timeA;
    });
},


        // Add this to your existing reducers
        addMoreUsers: (state, action) => {
            const newUsers = Array.isArray(action.payload) ? action.payload : [];
            const uniqueUsers = newUsers.filter(newUser =>
                !state.otherUsers.some(existingUser => existingUser._id === newUser._id)
            );

            state.otherUsers = [...state.otherUsers, ...uniqueUsers];

            // Update last messages and timestamps for new users
            uniqueUsers.forEach(user => {
                if (user.lastMessageTime) {
                    state.lastMessageTimestamps[user._id] = new Date(user.lastMessageTime).getTime();
                }
                if (user.lastMessageContent) {
                    state.lastMessages[user._id] = user.lastMessageContent;
                }
            });

            // Re-sort all users
            state.otherUsers.sort((a, b) => {
                const timeA = state.lastMessageTimestamps[a._id] || 0;
                const timeB = state.lastMessageTimestamps[b._id] || 0;
                return timeB - timeA;
              
            });
        },
        prependUser: (state, action) => {
            const newUser = action.payload;
            const exists = state.otherUsers.some(user => user._id === newUser._id);
            if (!exists) {
                state.otherUsers = [newUser, ...state.otherUsers];

                // Pagination adjust करें
                state.pagination = {
                    ...state.pagination,
                    totalUsers: state.pagination.totalUsers + 1,
                    totalPages: Math.ceil((state.pagination.totalUsers + 1) / state.pagination.limit)
                };
            }
        },

        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        resetPagination: (state) => {
            state.pagination = { page: 1, hasMore: true, loadingMore: false };
        },

        setAllUsers: (state, action) => {
            state.allUsers = Array.isArray(action.payload) ? action.payload : [];
        },
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload;
        },
        setOnlineUsers: (state, action) => {
            state.onlineUsers = action.payload;
        },

        incrementUnreadCount: (state, action) => {
            const { senderId, messageId } = action.payload;
            if (!senderId || !messageId) return;

            if (!state.unreadMessages) state.unreadMessages = {};
            if (!state.lastUnreadMessageId) state.lastUnreadMessageId = {};

            // Skip if already counted
            if (state.lastUnreadMessageId[senderId] === messageId) return;

            state.unreadMessages[senderId] = (state.unreadMessages[senderId] || 0) + 1;
            state.lastUnreadMessageId[senderId] = messageId;
        },

        clearUnreadCount: (state, action) => {
            const { userId } = action.payload;
            if (!userId || !state.unreadMessages) return;

            delete state.unreadMessages[userId];
            delete state.lastUnreadMessageId[userId];
        },

        //     updateLastMessageTimestamp: (state, action) => {
        //         const { userId, timestamp } = action.payload;
        //         if (!state.otherUsers) {
        //             state.otherUsers = [];
        //         }

        //         // Find and update the user's last message time
        //         state.otherUsers = state.otherUsers.map(user => {
        //             if (user._id === userId) {
        //                 return { ...user, lastMessageTime: timestamp };
        //             }
        //             return user;
        //         });

        //         // Re-sort users by timestamp
        //         // state.otherUsers = [...state.otherUsers].sort((a, b) => {
        //         //     const timeA = a.lastMessageTime ? new Date(a.lastMessageTime) : new Date(0);
        //         //     const timeB = b.lastMessageTime ? new Date(b.lastMessageTime) : new Date(0);
        //         //     return timeB - timeA;
        //         // });
        //            state.otherUsers = [...state.otherUsers].sort((a, b) => {
        //     const timeA = new Date(a.lastMessageTime || 0);
        //     const timeB = new Date(b.lastMessageTime || 0);
        //     return timeB - timeA;
        // });
        //     },

        updateLastMessageTimestamp: (state, action) => {
            const { userId, timestamp } = action.payload;

            // 1. नया array बनाएं
            const updatedUsers = state.otherUsers.map(user => {
                if (user._id === userId) {
                    return {
                        ...user,
                        lastMessageTime: timestamp
                    };
                }
                return user;
            });

            // 2. सॉर्ट करें और नया reference सेट करें
            state.otherUsers = updatedUsers.sort((a, b) => {
                const timeA = new Date(a.lastMessageTime || 0);
                const timeB = new Date(b.lastMessageTime || 0);
                return timeB - timeA;
            });
        },


        updateLastMessageContent: (state, action) => {
            const { userId, content } = action.payload;
            if (!state.lastMessages) state.lastMessages = {};
            state.lastMessages[userId] = content;

            // Also update the otherUsers array
            state.otherUsers = state.otherUsers.map(user => {
                if (user._id === userId) {
                    return {
                        ...user,
                        lastMessageContent: content,
                        // lastMessageTime: new Date().toISOString() 
                    };
                }
                return user;
            });
        },

        logoutUser: (state) => {
            state.authUser = null;
            state.otherUsers = [];
            state.selectedUser = null;
            state.onlineUsers = null;
            state.unreadMessages = {};
            state.lastMessageTimestamps = {};
            state.lastUnreadMessageId = {};
            state.lastMessages = {};
        },
        setSearchResults: (state, action) => {
    state.searchResults = action.payload;
},
clearSearchResults: (state) => {
    state.searchResults = null;
    
},
    }
});

export const {
    setAuthUser,
    setOtherUsers,
    addMoreUsers,
    prependUser,
    setPagination,
    resetPagination,
    setAllUsers,
    setSelectedUser,
    setOnlineUsers,
    incrementUnreadCount,
    clearUnreadCount,
    updateLastMessageTimestamp,
    updateLastMessageContent,
    logoutUser,
     setSearchResults,
     clearSearchResults
} = userSlice.actions;

export default userSlice.reducer;  